module.exports = __webpack_public_path__ + "static/img/1_07.1c98cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/1_07.png
// module id = RXZl
// module chunks = 6